/**
 * Como a nota foi efetivamente paga.
 *
 * Espelha o enum `FormaDePagamento` do backend e e gravado na nota e em cada baixa
 * que ela gera. Ate existir esse campo, tarjeta, QR Code e transferencia caiam todas
 * na mesma conta e ficavam indistinguiveis no fechamento do dia.
 *
 * Nao confundir com `CondicaoDePagamento` (CONTADO/CREDITO), que continua existindo e
 * diz se a venda gerou titulo.
 */
export enum FormaDePagamento {
  /** Especie, sem conta de destino. */
  CONTADO = 'CONTADO',
  /** Deposito ou transferencia bancaria em conta do sistema. */
  TRANSFERENCIA = 'TRANSFERENCIA',
  /** A prazo: a venda gera titulo e o recebimento vem depois. */
  CREDITO = 'CREDITO',
  /** Cartao pela maquininha/adquirente. */
  TARJETA = 'TARJETA',
  /** QR Code Bancard. */
  QR_CODE = 'QR_CODE',
}
